/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';

import { injectIntl, FormattedMessage } from 'react-intl';
import Link from '@quintoandar/cozy-core/Link';
import Illustration from '@quintoandar/cozy-core/Illustration';
import Typography from '@quintoandar/cozy-core/Typography/Typography';
import Box from '@quintoandar/cozy-core/Box';
import Grid from '@quintoandar/cozy-core/Grid';
import Divider from '@quintoandar/cozy-core/Divider';
import LaunchIcon from '@quintoandar/cozy-icons/Launch';

import { isMobile } from '@quintoandar/cozy-core/media/breakpoints';
import useWidth from '@quintoandar/cozy-utils/hooks/useWidth';

import { ERROR_TYPES } from './constants';
import messages from './messages';
import { GridWrapper, AlignedGrid } from './elements';
import { suggestionsContent } from './suggestionsContent';

const ErrorPage = ({ type, intl }) => {
  const width = useWidth();
  const isMobileWidth = isMobile(width);

  const description =
    type === ERROR_TYPES.NOT_FOUND
      ? messages.errorNotFoundDescription
      : messages.errorDescription;
  const header =
    type === ERROR_TYPES.NOT_FOUND
      ? messages.errorNotFoundHeader
      : messages.errorHeader;

  const buildSuggestion = (label, link, message) => (
    <Box p={1.2}>
      <Link
        icon={LaunchIcon}
        aria-label={intl.formatMessage(label)}
        message={message}
        href={intl.formatMessage(link)}
        target={'_self'}
      />
    </Box>
  );

  const suggestionsLinks = contents =>
    contents.map(content =>
      buildSuggestion(content.label, content.link, content.message),
    );

  return (
    <Box pt={12}>
      <GridWrapper container xs={12} isMobile={isMobileWidth}>
        <AlignedGrid item xs={isMobileWidth ? 12 : 6} isMobile={isMobileWidth}>
          <Box mr={3} mt={isMobileWidth ? 0 : 3}>
            <Illustration illustration="objects-empty-state" />
          </Box>
        </AlignedGrid>
        <Grid item xs={isMobileWidth ? 12 : 4}>
          <Box mt={8}>
            <Box p={1.2}>
              <Typography level="title">
                <FormattedMessage {...header} />
              </Typography>
            </Box>
            <Box p={1.2}>
              <Typography>
                <FormattedMessage {...description} />
              </Typography>
            </Box>
            <Divider pt={1.2} pb={1.2} pr={isMobile ? 0 : 5} />
            <Box p={1.2}>
              <Typography>
                <FormattedMessage {...messages.errorNotFoundLinks} />
              </Typography>
            </Box>
            {suggestionsLinks(suggestionsContent)}
          </Box>
        </Grid>
      </GridWrapper>
    </Box>
  );
};

ErrorPage.propTypes = {
  type: PropTypes.string,
  intl: PropTypes.object,
};

export { ErrorPage };
export default injectIntl(ErrorPage);
